import React from 'react';
import headerLogoGuestPay from '@images/headerLogoGuestPay.svg';
import { useNavigate } from 'react-router-dom';
import { usePaymentContext } from '../../Parking/paymentProcessor';
import './Style.scss';
const GuestPayHeader = () => {
    const navigate = useNavigate();
    const { setPaymentProcessor } = usePaymentContext();
    const handleReset = () => {
        setPaymentProcessor({
            vehicle: {},
            review: {},
            duration: {}
        });
        navigate('/');
    };
    return (
        <header id="guestPatHeader" className="header-style d-flex align-items-center justify-content-center">
            <div className="container py-3">
                <div className="d-flex align-items-center justify-content-center">
                    <img
                        onClick={handleReset}
                        id="headerLogoGuestPay"
                        className="cursor-pointer"
                        src={headerLogoGuestPay}
                        alt=""
                    />
                </div>
            </div>
        </header>
    );
};

export default GuestPayHeader;
